export const SEND_REGISTRATION = 'SEND_REGISTRATION';
export const SEND_REGISTRATION_REQUEST = 'SEND_REGISTRATION_REQUEST';
export const SEND_REGISTRATION_SUCCESS = 'SEND_REGISTRATION_SUCCESS';
export const SEND_REGISTRATION_FAILURE = 'SEND_REGISTRATION_FAILURE';
